import React, { FC } from 'react';
import returnTracking1 from '../../../assets/ReturnTracking1.png';
import returnTracking2 from '../../../assets/ReturnTracking2.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpAlert, HelpBody, HelpImage, HelpStep, HelpTitle } from './HelpElements';

const ReturnTrackingHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('returnTrackingHelp');

    return (
        <>
            <HelpTitle>{t('returnTrackingHelp_Title')}</HelpTitle>
            <HelpBody>{t('returnTrackingHelp_description')}</HelpBody>
            <HelpStep step={1}>{t('returnTrackingHelp_step1')}</HelpStep>
            <HelpStep step={2}>{t('returnTrackingHelp_step2')}</HelpStep>
            <HelpStep step={3}>{t('returnTrackingHelp_step3')}</HelpStep>
            <HelpStep step={4}>{t('returnTrackingHelp_step4')}</HelpStep>
            <HelpImage src={returnTracking1} />
            <HelpStep step={5}>{t('returnTrackingHelp_step5')}</HelpStep>
            <HelpImage src={returnTracking2} />
            <HelpAlert>{t('returnTrackingHelp_warning')}</HelpAlert>
        </>
    );
};

export { ReturnTrackingHelp };
